<template>
  <CRow>
    <CCol>
      <CCard class="p-3">
        <CCardHeader>
          <div class="countCard_Header d-flex justify-content-between content-center mb-4">
            <h5>{{ $t('planSubscription.overview.yourPlan.title') }}</h5>

            <span>
              <CIcon name="recover" size="custom-size" :height="18" viewBox="0 0 32 32" class="mr-1" />
              {{ $t('planSubscription.overview.yourPlan.subscriberSince') }}
              {{ formatDateMountNameAndYear(currentPlan.beginDateTime) }}</span
            >
          </div>
        </CCardHeader>
        <CCardBody class="">
          <h6>{{ $t('planSubscription.overview.yourPlan.currentPlan') }}:</h6>
          <div class="currentPlan mt-3">
            <CRow alignVertical="center">
              <CCol sm="3" class="currentPlanColOne">
                <h6>{{ planName }}</h6>
              </CCol>
              <CCol sm="6" class="currentPlanColTwo">
                <h6 class="mb-3">
                  {{ $t('planSubscription.overview.yourPlan.featuresIn') }} {{ $t('planSubscription.overview.yourPlan.plan', { planName }) }}:
                </h6>
                <div class="blockFeatures mt-2" v-for="ft in currentPlan.features" :key="ft.id">
                  <CIcon class="checkMark mr-1" name="checkMark" :height="15" viewBox="0 0 32 32" />
                  {{ $t(ft.featureName, { maxEmailsPerMonth: maxEmailsPerMonthFormatted }) }}
                </div>
              </CCol>

              <!-- Quando o plano é de subscrição e não foi cancelado -->
              <CCol v-if="(isSubscribe || isFree) && !currentPlan.endDateTime" sm="3" class="currentPlanColThree">
                <CRow alignVertical="center">
                  <CCol sm="12">
                    <div class="nextInvoice py-5">
                      <span>{{
                        isSubscribe ? $t('planSubscription.overview.yourPlan.nextInvoice') : $t('planSubscription.overview.yourPlan.nextRenewal')
                      }}</span>
                      <h6 class="mt-1">{{ formatStringMed(currentPlan.nextInvoice) }}</h6>
                    </div>
                  </CCol>
                  <CCol v-if="isSubscribe" sm="12">
                    <div class="paidPerMonth py-5">
                      <span v-if="isMonthlyPlan">{{ $t('planSubscription.overview.yourPlan.paidPerMonth') }}</span>
                      <span v-if="isYearlyPlan">{{ $t('planSubscription.overview.yourPlan.paidPerYear') }}</span>
                      <h6 class="mt-1">{{ formatPrice(currentPlan.amount) }}</h6>
                    </div>
                  </CCol>
                </CRow>
              </CCol>

              <!-- Quando o plano é de subscrição e foi cancelado -->
              <CCol v-if="isSubscribe && currentPlan.endDateTime" sm="3" class="currentPlanColThree">
                <CRow alignVertical="center">
                  <CCol sm="12">
                    <div class="py-5">
                      <h6 class="mt-1 canceled-plan">
                        <div v-html="formatCanceledText()"></div>
                      </h6>
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </div>

          <div class="my-4 text-right">
            <CButton
              v-if="isSubscribe && currentPlan.endDateTime"
              color="primary"
              class="py-2 px-4"
              @click="$router.push({ name: 'manage-balance-plans' })"
            >
              {{ $t('planSubscription.overview.yourPlan.button.renewPlan') }}
            </CButton>
          </div>

          <OverViewChangeOrCancelPlan
            v-if="!currentPlan.endDateTime && !isCorporate"
            :isFree="isFree"
            @error="emitError"
            :nextInvoice="currentPlan.nextInvoice"
          />

          <OverViewAddons
            v-if="!isFree && !isCorporate"
            :addons="addons"
            :isSubscribe="isSubscribe"
            :nextInvoice="currentPlan.nextInvoice"
            @cancelAddonSuccess="cancelAddonSuccess"
            @cancelAddonError="cancelAddonError"
          />

          <!-- <div class="countCard_Header d-flex justify-content-between content-center mt-5">
            <h6>Total cost:</h6>
            <div>
              <div class="totalPriceMessage">
                This is the total cost of all your products,<br />
                including addtional packges and fees.
              </div>
              <div class="totalPriceOverview">310.00 €</div>
            </div>
          </div> -->
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import OverViewChangeOrCancelPlan from '../components/OverViewChangeOrCancelPlan.vue'
import OverViewAddons from '../components/OverViewAddons.vue'
import { currencyFormat } from '@/utils/numbersFormatUtil'
import { dateFormatMountNameAndYear, dateFormatStringMed, daysToDate } from '@/utils/dateUtil'
import { enumPlanPeriod } from '@/utils/enumsUtils.js'

const planNames = {
  free: 'Free',
  starter: 'Starter',
  professional: 'Professional',
  business: 'Business',
  payAsYouGo: 'PayAsYouGo',
}

export default {
  name: 'OverViewYourPlan',
  components: {
    OverViewChangeOrCancelPlan,
    OverViewAddons,
  },
  props: {
    currentPlan: {
      type: Object,
      default: () => {},
    },
    isSubscribe: {
      type: Boolean,
      default: false,
    },
    isFree: {
      type: Boolean,
      default: false,
    },
    isCorporate: {
      type: Boolean,
      default: false,
    },
    addons: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      planNames,
    }
  },
  computed: {
    planName: function () {
      if (this.currentPlan?.plan?.name == this.planNames.payAsYouGo) return 'Pay As You Go'
      return this.currentPlan?.plan?.name || ' '
    },
    planPeriod() {
      return enumPlanPeriod(this.currentPlan.paymentPeriod)
    },
    isMonthlyPlan() {
      return this.planPeriod == enumPlanPeriod(1)
    },
    isYearlyPlan() {
      return this.planPeriod == enumPlanPeriod(3)
    },
    maxEmailsPerMonthFormatted() {
      return this.currentPlan?.planTier?.maxEmailsPerMonth?.toLocaleString()
    },
  },
  methods: {
    cancelAddonSuccess(obj) {
      this.$emit('cancelAddonSuccess', obj)
    },
    cancelAddonError(obj) {
      this.$emit('cancelAddonError', obj)
    },
    daysToEndPlan(value) {
      return daysToDate(value, 'utc')
    },
    formatPrice(value) {
      return currencyFormat(value)
    },
    formatDateMountNameAndYear(date) {
      return dateFormatMountNameAndYear(date)
    },
    formatStringMed(date) {
      return dateFormatStringMed(date)
    },
    emitError(data) {
      this.$emit('error', data)
    },
    formatCanceledText() {
      return this.$t('planSubscription.overview.yourPlan.canceledText', {
        date: `<span>${this.formatStringMed(this.currentPlan.endDateTime)}</span>`,
      })
    },
  },
}
</script>

<style lang="scss" scope>
.totalPriceOverview {
  text-align: right;
  color: #343a40;
  font-weight: bold;
}
.totalPriceMessage {
  color: #868e96;
  font-size: 12px;
  text-align: right;
}
.currentPlan {
  border-radius: 10px;
  border: 1px solid #dee2e6;
  padding: 20px;
}

.currentPlanColOne {
  border-right: 1px solid #dee2e6;
  text-align: center;
  padding: 50px 20px;
}

.currentPlanColOne h6 {
  font-size: 0.9rem;
  line-height: 140px;
}

.currentPlanColTwo {
  padding: 10px 30px;
}

.currentPlanColTwo h6 {
  font-size: 0.9rem;
}

.checkMark {
  color: $primary !important;
}

.blockFeatures {
  color: #343a40;
  font-size: 14px;
}

.currentPlanColThree {
  border-left: 1px solid #dee2e6;
  text-align: center;
}

.nextInvoice {
  height: 50%;
  font-size: 14px;
}

.paidPerMonth {
  height: 50%;
  border-top: 1px solid #dee2e6;
  font-size: 14px;
}

.paidPerMonth span {
  color: #868e96;
}

.nextInvoice span {
  color: #868e96;
}

.canceled-plan {
  height: 50%;
  color: $gray-400;
  font-size: $font-size-xs;
  font-weight: $font-weight-semi-bold;
  line-height: 1.4em;
}

.canceled-plan span {
  color: $gray-base;
  font-weight: $font-weight-bold;
}
</style>
